const data = [
  { countryCode: "IN", value: "91", name: "India (+91)", phoneLength: 10 },
  { countryCode: "US", value: "1", name: "USA (+1)", phoneLength: 10 },
  { countryCode: "DZ", value: "213", name: "Algeria (+213)", phoneLength: 9 },
  { countryCode: "AD", value: "376", name: "Andorra (+376)", phoneLength: 6 },
  { countryCode: "AO", value: "244", name: "Angola (+244)", phoneLength: 9 },
  { countryCode: "AI", value: "1264", name: "Anguilla (+1264)", phoneLength: 7 },
  { countryCode: "AG", value: "1268", name: "Antigua & Barbuda (+1268)", phoneLength: 7 },
  { countryCode: "AR", value: "54", name: "Argentina (+54)", phoneLength: 10 },
  { countryCode: "AM", value: "374", name: "Armenia (+374)", phoneLength: 8 },
  { countryCode: "AW", value: "297", name: "Aruba (+297)", phoneLength: 7 },
  { countryCode: "AU", value: "61", name: "Australia (+61)", phoneLength: 9 },
  { countryCode: "AT", value: "43", name: "Austria (+43)", phoneLength: 9 },
  { countryCode: "AZ", value: "994", name: "Azerbaijan (+994)", phoneLength: 9 },
  { countryCode: "BS", value: "1242", name: "Bahamas (+1242)", phoneLength: 7 },
  { countryCode: "BH", value: "973", name: "Bahrain (+973)", phoneLength: 8 },
  { countryCode: "BD", value: "880", name: "Bangladesh (+880)", phoneLength: 10 },
  { countryCode: "BB", value: "1246", name: "Barbados (+1246)", phoneLength: 7 },
  { countryCode: "BY", value: "375", name: "Belarus (+375)", phoneLength: 9 },
  { countryCode: "BE", value: "32", name: "Belgium (+32)", phoneLength: 9 },
  { countryCode: "BZ", value: "501", name: "Belize (+501)", phoneLength: 7 },
  { countryCode: "BJ", value: "229", name: "Benin (+229)", phoneLength: 8 },
  { countryCode: "BM", value: "1441", name: "Bermuda (+1441)", phoneLength: 7 },
  { countryCode: "BT", value: "975", name: "Bhutan (+975)", phoneLength: 8 },
  { countryCode: "BO", value: "591", name: "Bolivia (+591)", phoneLength: 8 },
  { countryCode: "BA", value: "387", name: "Bosnia Herzegovina (+387)", phoneLength: 8 },
  { countryCode: "BW", value: "267", name: "Botswana (+267)", phoneLength: 7 },
  { countryCode: "BR", value: "55", name: "Brazil (+55)", phoneLength: 11 },
  { countryCode: "BN", value: "673", name: "Brunei (+673)", phoneLength: 7 },
  { countryCode: "BG", value: "359", name: "Bulgaria (+359)", phoneLength: 8 },
  { countryCode: "BF", value: "226", name: "Burkina Faso (+226)", phoneLength: 8 },
  { countryCode: "BI", value: "257", name: "Burundi (+257)", phoneLength: 8 },
  { countryCode: "KH", value: "855", name: "Cambodia (+855)", phoneLength: 8 },
  { countryCode: "CM", value: "237", name: "Cameroon (+237)", phoneLength: 9 },
  { countryCode: "CA", value: "1", name: "Canada (+1)", phoneLength: 10 },
  { countryCode: "CV", value: "238", name: "Cape Verde Islands (+238)", phoneLength: 7 },
  { countryCode: "KY", value: "1345", name: "Cayman Islands (+1345)", phoneLength: 7 },
  { countryCode: "CF", value: "236", name: "Central African Republic (+236)", phoneLength: 7 },
  { countryCode: "CL", value: "56", name: "Chile (+56)", phoneLength: 9 },
  { countryCode: "CN", value: "86", name: "China (+86)", phoneLength: 11 },
  { countryCode: "CO", value: "57", name: "Colombia (+57)", phoneLength: 10 },
  { countryCode: "KM", value: "269", name: "Comoros (+269)", phoneLength: 7 },
  { countryCode: "CG", value: "242", name: "Congo (+242)", phoneLength: 9 },
  { countryCode: "CK", value: "682", name: "Cook Islands (+682)", phoneLength: 5 },
  { countryCode: "CR", value: "506", name: "Costa Rica (+506)", phoneLength: 8 },
  { countryCode: "HR", value: "385", name: "Croatia (+385)", phoneLength: 9 },
  { countryCode: "CU", value: "53", name: "Cuba (+53)", phoneLength: 8 },
  { countryCode: "CY", value: "90392", name: "Cyprus North (+90392)", phoneLength: 6 },
  { countryCode: "CY", value: "357", name: "Cyprus South (+357)", phoneLength: 8 },
  { countryCode: "CZ", value: "42", name: "Czech Republic (+42)", phoneLength: 9 },
  { countryCode: "DK", value: "45", name: "Denmark (+45)", phoneLength: 8 },
  { countryCode: "DJ", value: "253", name: "Djibouti (+253)", phoneLength: 7 },
  { countryCode: "DM", value: "1809", name: "Dominica (+1809)", phoneLength: 7 },
  { countryCode: "DO", value: "1809", name: "Dominican Republic (+1809)", phoneLength: 7 },
  { countryCode: "EC", value: "593", name: "Ecuador (+593)", phoneLength: 9 },
  { countryCode: "EG", value: "20", name: "Egypt (+20)", phoneLength: 9 },
  { countryCode: "SV", value: "503", name: "El Salvador (+503)", phoneLength: 8 },
  { countryCode: "GQ", value: "240", name: "Equatorial Guinea (+240)", phoneLength: 7 },
  { countryCode: "ER", value: "291", name: "Eritrea (+291)", phoneLength: 7 },
  { countryCode: "EE", value: "372", name: "Estonia (+372)", phoneLength: 7 },
  { countryCode: "ET", value: "251", name: "Ethiopia (+251)", phoneLength: 9 },
  { countryCode: "FK", value: "500", name: "Falkland Islands (+500)", phoneLength: 5 },
  { countryCode: "FO", value: "298", name: "Faroe Islands (+298)", phoneLength: 6 },
  { countryCode: "FJ", value: "679", name: "Fiji (+679)", phoneLength: 7 },
  { countryCode: "FI", value: "358", name: "Finland (+358)", phoneLength: 7 },
  { countryCode: "FR", value: "33", name: "France (+33)", phoneLength: 9 },
  { countryCode: "GF", value: "594", name: "French Guiana (+594)", phoneLength: 9 },
  { countryCode: "PF", value: "689", name: "French Polynesia (+689)", phoneLength: 6 },
  { countryCode: "GA", value: "241", name: "Gabon (+241)", phoneLength: 7 },
  { countryCode: "GM", value: "220", name: "Gambia (+220)", phoneLength: 7 },
  { countryCode: "GE", value: "7880", name: "Georgia (+7880)", phoneLength: 6 },
  { countryCode: "DE", value: "49", name: "Germany (+49)", phoneLength: 10 },
  { countryCode: "GH", value: "233", name: "Ghana (+233)", phoneLength: 9 },
  { countryCode: "GI", value: "350", name: "Gibraltar (+350)", phoneLength: 8 },
  { countryCode: "GR", value: "30", name: "Greece (+30)", phoneLength: 10 },
  { countryCode: "GL", value: "299", name: "Greenland (+299)", phoneLength: 6 },
  { countryCode: "GD", value: "1473", name: "Grenada (+1473)", phoneLength: 7 },
  { countryCode: "GP", value: "590", name: "Guadeloupe (+590)", phoneLength: 9 },
  { countryCode: "GU", value: "671", name: "Guam (+671)", phoneLength: 7 },
  { countryCode: "GT", value: "502", name: "Guatemala (+502)", phoneLength: 8 },
  { countryCode: "GN", value: "224", name: "Guinea (+224)", phoneLength: 8 },
  { countryCode: "GW", value: "245", name: "Guinea - Bissau (+245)", phoneLength: 7 },
  { countryCode: "GY", value: "592", name: "Guyana (+592)", phoneLength: 7 },
  { countryCode: "HT", value: "509", name: "Haiti (+509)", phoneLength: 8 },
  { countryCode: "HN", value: "504", name: "Honduras (+504)", phoneLength: 8 },
  { countryCode: "HK", value: "852", name: "Hong Kong (+852)", phoneLength: 8 },
  { countryCode: "HU", value: "36", name: "Hungary (+36)", phoneLength: 9 },
  { countryCode: "IS", value: "354", name: "Iceland (+354)", phoneLength: 7 },
  { countryCode: "ID", value: "62", name: "Indonesia (+62)", phoneLength: 10 },
  { countryCode: "IR", value: "98", name: "Iran (+98)", phoneLength: 10 },
  { countryCode: "IQ", value: "964", name: "Iraq (+964)", phoneLength: 10 },
  { countryCode: "IE", value: "353", name: "Ireland (+353)", phoneLength: 7 },
  { countryCode: "IL", value: "972", name: "Israel (+972)", phoneLength: 9 },
  { countryCode: "IT", value: "39", name: "Italy (+39)", phoneLength: 10 },
  { countryCode: "JM", value: "1876", name: "Jamaica (+1876)", phoneLength: 7 },
  { countryCode: "JP", value: "81", name: "Japan (+81)", phoneLength: 10 },
  { countryCode: "JO", value: "962", name: "Jordan (+962)", phoneLength: 9 },
  { countryCode: "KZ", value: "7", name: "Kazakhstan (+7)", phoneLength: 10 },
  { countryCode: "KE", value: "254", name: "Kenya (+254)", phoneLength: 9 },
  { countryCode: "KI", value: "686", name: "Kiribati (+686)", phoneLength: 5 },
  { countryCode: "KP", value: "850", name: "Korea North (+850)", phoneLength: 8 },
  { countryCode: "KR", value: "82", name: "Korea South (+82)", phoneLength: 9 },
  { countryCode: "KW", value: "965", name: "Kuwait (+965)", phoneLength: 8 },
  { countryCode: "KG", value: "996", name: "Kyrgyzstan (+996)", phoneLength: 9 },
  { countryCode: "LA", value: "856", name: "Laos (+856)", phoneLength: 8 },
  { countryCode: "LV", value: "371", name: "Latvia (+371)", phoneLength: 8 },
  { countryCode: "LB", value: "961", name: "Lebanon (+961)", phoneLength: 8 },
  { countryCode: "LS", value: "266", name: "Lesotho (+266)", phoneLength: 7 },
  { countryCode: "LR", value: "231", name: "Liberia (+231)", phoneLength: 7 },
  { countryCode: "LY", value: "218", name: "Libya (+218)", phoneLength: 8 },
  { countryCode: "LI", value: "417", name: "Liechtenstein (+417)", phoneLength: 7 },
  { countryCode: "LT", value: "370", name: "Lithuania (+370)", phoneLength: 8 },
  { countryCode: "LU", value: "352", name: "Luxembourg (+352)", phoneLength: 8 },
  { countryCode: "MO", value: "853", name: "Macao (+853)", phoneLength: 8 },
  { countryCode: "MK", value: "389", name: "Macedonia (+389)", phoneLength: 7 },
  { countryCode: "MG", value: "261", name: "Madagascar (+261)", phoneLength: 9 },
  { countryCode: "MW", value: "265", name: "Malawi (+265)", phoneLength: 7 },
  { countryCode: "MY", value: "60", name: "Malaysia (+60)", phoneLength: 9 },
  { countryCode: "MV", value: "960", name: "Maldives (+960)", phoneLength: 7 },
  { countryCode: "ML", value: "223", name: "Mali (+223)", phoneLength: 8 },
  { countryCode: "MT", value: "356", name: "Malta (+356)", phoneLength: 8 },
  { countryCode: "MH", value: "692", name: "Marshall Islands (+692)", phoneLength: 7 },
  { countryCode: "MQ", value: "596", name: "Martinique (+596)", phoneLength: 9 },
  { countryCode: "MR", value: "222", name: "Mauritania (+222)", phoneLength: 8 },
  { countryCode: "YT", value: "269", name: "Mayotte (+269)", phoneLength: 7 },
  { countryCode: "MX", value: "52", name: "Mexico (+52)", phoneLength: 10 },
  { countryCode: "FM", value: "691", name: "Micronesia (+691)", phoneLength: 7 },
  { countryCode: "MD", value: "373", name: "Moldova (+373)", phoneLength: 8 },
  { countryCode: "MC", value: "377", name: "Monaco (+377)", phoneLength: 8 },
  { countryCode: "MN", value: "976", name: "Mongolia (+976)", phoneLength: 8 },
  { countryCode: "MS", value: "1664", name: "Montserrat (+1664)", phoneLength: 7 },
  { countryCode: "MA", value: "212", name: "Morocco (+212)", phoneLength: 9 },
  { countryCode: "MZ", value: "258", name: "Mozambique (+258)", phoneLength: 9 },
  { countryCode: "MN", value: "95", name: "Myanmar (+95)", phoneLength: 7 },
  { countryCode: "NA", value: "264", name: "Namibia (+264)", phoneLength: 7 },
  { countryCode: "NR", value: "674", name: "Nauru (+674)", phoneLength: 5 },
  { countryCode: "NP", value: "977", name: "Nepal (+977)", phoneLength: 10 },
  { countryCode: "NL", value: "31", name: "Netherlands (+31)", phoneLength: 9 },
  { countryCode: "NC", value: "687", name: "New Caledonia (+687)", phoneLength: 6 },
  { countryCode: "NZ", value: "64", name: "New Zealand (+64)", phoneLength: 9 },
  { countryCode: "NI", value: "505", name: "Nicaragua (+505)", phoneLength: 8 },
  { countryCode: "NE", value: "227", name: "Niger (+227)", phoneLength: 8 },
  { countryCode: "NG", value: "234", name: "Nigeria (+234)", phoneLength: 7 },
  { countryCode: "NU", value: "683", name: "Niue (+683)", phoneLength: 4 },
  { countryCode: "NF", value: "672", name: "Norfolk Islands (+672)", phoneLength: 6 },
  { countryCode: "NP", value: "670", name: "Northern Marianas (+670)", phoneLength: 7 },
  { countryCode: "NO", value: "47", name: "Norway (+47)", phoneLength: 8 },
  { countryCode: "OM", value: "968", name: "Oman (+968)", phoneLength: 8 },
  { countryCode: "PW", value: "680", name: "Palau (+680)", phoneLength: 7 },
  { countryCode: "PA", value: "507", name: "Panama (+507)", phoneLength: 7 },
  { countryCode: "PG", value: "675", name: "Papua New Guinea (+675)", phoneLength: 7 },
  { countryCode: "PY", value: "595", name: "Paraguay (+595)", phoneLength: 9 },
  { countryCode: "PE", value: "51", name: "Peru (+51)", phoneLength: 9 },
  { countryCode: "PH", value: "63", name: "Philippines (+63)", phoneLength: 10 },
  { countryCode: "PL", value: "48", name: "Poland (+48)", phoneLength: 9 },
  { countryCode: "PT", value: "351", name: "Portugal (+351)", phoneLength: 9 },
  { countryCode: "PR", value: "1787", name: "Puerto Rico (+1787)", phoneLength: 7 },
  { countryCode: "QA", value: "974", name: "Qatar (+974)", phoneLength: 8 },
  { countryCode: "RE", value: "262", name: "Reunion (+262)", phoneLength: 9 },
  { countryCode: "RO", value: "40", name: "Romania (+40)", phoneLength: 9 },
  { countryCode: "RU", value: "7", name: "Russia (+7)", phoneLength: 10 },
  { countryCode: "RW", value: "250", name: "Rwanda (+250)", phoneLength: 9 },
  { countryCode: "SM", value: "378", name: "San Marino (+378)", phoneLength: 6 },
  { countryCode: "ST", value: "239", name: "Sao Tome & Principe (+239)", phoneLength: 7 },
  { countryCode: "SA", value: "966", name: "Saudi Arabia (+966)", phoneLength: 9 },
  { countryCode: "SN", value: "221", name: "Senegal (+221)", phoneLength: 9 },
  { countryCode: "CS", value: "381", name: "Serbia (+381)", phoneLength: 8 },
  { countryCode: "SC", value: "248", name: "Seychelles (+248)", phoneLength: 7 },
  { countryCode: "SL", value: "232", name: "Sierra Leone (+232)", phoneLength: 7 },
  { countryCode: "SG", value: "65", name: "Singapore (+65)", phoneLength: 8 },
  { countryCode: "SK", value: "421", name: "Slovak Republic (+421)", phoneLength: 9 },
  { countryCode: "SI", value: "386", name: "Slovenia (+386)", phoneLength: 8 },
  { countryCode: "SB", value: "677", name: "Solomon Islands (+677)", phoneLength: 7 },
  { countryCode: "SO", value: "252", name: "Somalia (+252)", phoneLength: 8 },
  { countryCode: "ZA", value: "27", name: "South Africa (+27)", phoneLength: 9 },
  { countryCode: "ES", value: "34", name: "Spain (+34)", phoneLength: 9 },
  { countryCode: "LK", value: "94", name: "Sri Lanka (+94)", phoneLength: 7 },
  { countryCode: "SH", value: "290", name: "St. Helena (+290)", phoneLength: 5 },
  { countryCode: "KN", value: "1869", name: "St. Kitts (+1869)", phoneLength: 7 },
  { countryCode: "SC", value: "1758", name: "St. Lucia (+1758)", phoneLength: 7 },
  { countryCode: "SD", value: "249", name: "Sudan (+249)", phoneLength: 9 },
  { countryCode: "SR", value: "597", name: "Suriname (+597)", phoneLength: 7 },
  { countryCode: "SZ", value: "268", name: "Swaziland (+268)", phoneLength: 7 },
  { countryCode: "SE", value: "46", name: "Sweden (+46)", phoneLength: 9 },
  { countryCode: "CH", value: "41", name: "Switzerland (+41)", phoneLength: 9 },
  { countryCode: "SI", value: "963", name: "Syria (+963)", phoneLength: 9 },
  { countryCode: "TW", value: "886", name: "Taiwan (+886)", phoneLength: 9 },
  { countryCode: "TJ", value: "7", name: "Tajikstan (+7)", phoneLength: 10 },
  { countryCode: "TH", value: "66", name: "Thailand (+66)", phoneLength: 9 },
  { countryCode: "TG", value: "228", name: "Togo (+228)", phoneLength: 8 },
  { countryCode: "TO", value: "676", name: "Tonga (+676)", phoneLength: 5 },
  { countryCode: "TT", value: "1868", name: "Trinidad & Tobago (+1868)", phoneLength: 7 },
  { countryCode: "TN", value: "216", name: "Tunisia (+216)", phoneLength: 8 },
  { countryCode: "TR", value: "90", name: "Turkey (+90)", phoneLength: 10 },
  { countryCode: "TM", value: "7", name: "Turkmenistan (+7)", phoneLength: 10 },
  { countryCode: "TM", value: "993", name: "Turkmenistan (+993)", phoneLength: 8 },
  { countryCode: "TC", value: "1649", name: "Turks & Caicos Islands (+1649)", phoneLength: 7 },
  { countryCode: "TV", value: "688", name: "Tuvalu (+688)", phoneLength: 5 },
  { countryCode: "UG", value: "256", name: "Uganda (+256)", phoneLength: 9 },
  { countryCode: "GB", value: "44", name: "UK (+44)", phoneLength: 10 },
  { countryCode: "UA", value: "380", name: "Ukraine (+380)", phoneLength: 9 },
  { countryCode: "AE", value: "971", name: "United Arab Emirates (+971)", phoneLength: 9 },
  { countryCode: "UY", value: "598", name: "Uruguay (+598)", phoneLength: 8 },
  { countryCode: "UZ", value: "7", name: "Uzbekistan (+7)", phoneLength: 9 },
  { countryCode: "VU", value: "678", name: "Vanuatu (+678)", phoneLength: 5 },
  { countryCode: "VA", value: "379", name: "Vatican City (+379)", phoneLength: 6 },
  { countryCode: "VE", value: "58", name: "Venezuela (+58)", phoneLength: 10 },
  { countryCode: "VN", value: "84", name: "Vietnam (+84)", phoneLength: 9 },
  { countryCode: "VG", value: "1284", name: "Virgin Islands - British (+1284)", phoneLength: 7 },
  { countryCode: "VI", value: "1340", name: "Virgin Islands - US (+1340)", phoneLength: 7 },
  { countryCode: "WF", value: "681", name: "Wallis & Futuna (+681)", phoneLength: 6 },
  { countryCode: "YE", value: "969", name: "Yemen (North)(+969)", phoneLength: 9 },
  { countryCode: "YE", value: "967", name: "Yemen (South)(+967)", phoneLength: 9 },
  { countryCode: "ZM", value: "260", name: "Zambia (+260)", phoneLength: 9 },
  { countryCode: "ZW", value: "263", name: "Zimbabwe (+263)", phoneLength: 9 },
];

const updatedData = data.map((item) => {
  const [countryNamePart, codePart] = item.name.split(" (");
  return {
    ...item,
    countryName: countryNamePart.trim().toLowerCase(), // clean lowercase name
    dialCode: codePart.replace(")", "").trim(),        // like +91, +260 etc.
  };
});

// Get country name from country code (e.g., "IN" → "india")
function getCountryNameFromCode(code) {
  const country = updatedData.find(
    (item) => item.countryCode === code.toUpperCase()
  );
  return country ? country.countryName : null; // ✅ use cleaned name
}

// Get country code from country name (e.g., "india" → "IN")
function getCountryCodeFromName(name) {
  const country = updatedData.find(
    (item) => item.countryName === name.trim().toLowerCase()
  );
  return country ? country.value : null; // ✅ return ISO code, not dial code
}

// Get country name from dial code value (e.g., "91" → "india")
function getCountryNameFromValue(value) {
  const country = updatedData.find(
    (item) => item.value === value.trim()
  );
  return country ? country.countryName : null; // returns cleaned lowercase name
}

// Get countryCode (ISO) from dial code value (e.g., "91" → "IN")
function getCountryCodeFromValue(value) {
  const country = updatedData.find(
    (item) => item.value === value.trim()
  );
  return country ? country.countryCode : null;
}


export { getCountryNameFromCode, getCountryCodeFromName, getCountryNameFromValue, getCountryCodeFromValue };

